module.exports = __webpack_public_path__ + "static/life-74b8015b64e1d06747eabf53285dda65.png";